import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import CreatorBenefits from '../../CreatorBenefits/CreatorBenefits';
import VideoLoop from '../../VideoLoop/VideoLoop';
import creatorsVideo from '../../../assets/videos/desktop-home-creators.mp4';
import './ThisIsYourMoment.css';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { shouldRenderVideoEmbed } from '../../../config/videoEmbeds';

/**
 * Mid-page section with scrolling headline and creator benefits plus optional hero clip.
 * Exports:
 * - default: React component; omits VideoLoop when disabled in videoEmbeds config.
 */
const SCREEN_WIDTH = typeof window !== 'undefined' ? window.innerWidth : 1280;

const ThisIsYourMoment = () => {
  const showCreatorsVideo = shouldRenderVideoEmbed('thisIsYourMoment');
  const { scrollYProgress } = useScroll();
  const isMobile = useIsMobile();
  let xStart = isMobile ? SCREEN_WIDTH*4 : SCREEN_WIDTH*2.5;
  let xEnd = isMobile ? -SCREEN_WIDTH*2.1 : -SCREEN_WIDTH*1.1;
  
  // Transform scrollYProgress (0-1) to x position for marquee effect
  // Starting from right (0) and moving further left (-2000)
  const x = useTransform(scrollYProgress, [0, 1], [xStart, xEnd]);
  const repetitions = 4; // Number of times to repeat the text

  return (
    <section id="this-is-your-moment" className="this-is-your-moment-section">
      <div className="container">
        <motion.div 
          className="marquee-container"
          style={{ x }}
        >
          <motion.div 
            className="marquee-content"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {[...Array(repetitions)].map((_, index) => (
              <h1 key={index} className="moment-heading">
                THIS IS <span className="creative-highlight">YOUR</span> MOMENT
                <span className="spacer">&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </h1>
            ))}
          </motion.div>
        </motion.div>
        
        <div className="content-container">
          <CreatorBenefits />
          {showCreatorsVideo && <VideoLoop src={creatorsVideo} />}
        </div>
      </div>
    </section>
  );
};

export default ThisIsYourMoment; 